export const COMBO_LOCALE = {
    placeholder: 'Please Select',
    emptyMsg: 'Empty Data',
};
